import React from "react"
import {PropTypes} from 'prop-types';

import {Button, Col, Row} from "reactstrap";
import PasswordField from "./PasswordField";

import {salesforcePush, startVerification, deleteVerification} from "../../../actions/verifActions";
import {connect} from "react-redux";
import Timeline from "../Timeline";
import {withRouter} from "react-router-dom";
import Popup from "react-popup";
import SalesforcePushModal from "./SalesforcePushModal";

class Actions extends React.Component {

  constructor(props) {
    super(props);
    this.c = 0
    this.state = {
      options: {
        no_shred: false,
        no_virus: false,
      },
      passwords: [],
      salesforcemodal: false
    };

    console.log(props)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {protectedarchives} = this.props
    if (prevProps.protectedarchives != protectedarchives) {
      this.setState(({passwords}) => ({passwords: []}))
      Object.keys(protectedarchives).map((k) => this.addPassword(protectedarchives[k]['path'],k))
    }
  }

  toggleOption(key) {
    this.setState(({options}) => ({options: {...options, [key]: !options[key]}}))
  }

  addPassword(filename="", hash="", pass="") {
    this.setState(({passwords}) => ({passwords: [...passwords, {id: this.c++, filename: filename, hash: hash, pass: pass}]}))
  }

  removePassword(i) {
    const {passwords} = this.state
    passwords.splice(i, 1)
    this.setState(({passwords}) => ({passwords: [...passwords]}))
  }

  updatePassword(i, key, value) {
    const {passwords} = this.state
    passwords[i] = {...passwords[i] ,[key]: value}
    this.setState(({passwords}) => ({passwords: [...passwords]}))
  }

  toggleSalesforce() {
    this.setState(({salesforcemodal}) => ({salesforcemodal: !salesforcemodal}))
  }

  render() {
    const st = {
      className:'mr-1 mb-1',
    }

    return <Row>
      <Col xs={6}>
        <h3>Verif actions</h3>
        <Button {...st} onClick={()=>this.props.startVerification(this.props.depo_id, {...this.state.options, passwords: this.state.passwords.reduce((obj, item)=>{obj[item.hash]=item.pass;return obj},{})})}>Re-run verification</Button>
        {/*<Button {...st} disabled>Re-run with</Button>*/}
        <Button {...st} onClick={()=>this.toggleSalesforce()}>Push to salesforce</Button>
        <SalesforcePushModal isOpen={this.state.salesforcemodal} toggle={()=>this.toggleSalesforce()} callback={(val)=>this.props.salesforcePush(this.props.verif_id, val)}/>
        {/*<Button {...st} disabled>Delete</Button>*/}
        <Button {...st} onClick={()=>this.props.deleteVerification(this.props.depo_id, this.props.verif_id)}>Delete</Button>
        <br/>
        <h4>options</h4>
        {Object.entries(this.state.options).map(([k, v]) =>
          <Button size="sm" color={v?"success":"muted"} onClick={() => this.toggleOption(k)}>{k} {v?"yes":"no"}</Button>
        )}
      </Col>
      <Col xs={6}>
        {/*<pre>{JSON.stringify(this.state, 0, 2)}</pre>*/}
        <h4>Passwords <Button size="sm" onClick={()=>this.addPassword()}>+</Button></h4>
        <pre>{JSON.stringify(this.state.passwords.reduce((obj, item)=>{obj[item.hash]=item.pass;return obj},{}))}</pre>
        {this.state.passwords.map((entry, i) => <PasswordField key={entry.id} onChange={(k, v)=> this.updatePassword(i, k, v)} onRemove={()=>this.removePassword(i)} filename={entry.filename} hash={entry.hash} pass={JSON.stringify(entry.pass)}/>)}
      </Col>
    </Row>
  }
}

const mapDispatchToProps = (dispatch) => ({
  startVerification: (depoId, options) => dispatch(startVerification(depoId, options)),
  deleteVerification: (depoId, verifId) => dispatch(deleteVerification(depoId, verifId)),
  salesforcePush: (verifId, contract_id) => dispatch(salesforcePush(verifId, contract_id))
})

const mapStateToProps = (state) => ({
  depo_id: state.verification.data.depo_id
})


Actions.defaultProps = {
  protectedarchives: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(Actions)



// WEBPACK FOOTER //
// ./src/components/Verification/Actions/index.js